import patchTransports from './transports.js';
import methods from './methods.js';

export default patchTransports(methods);
